module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Logout":"Logout","Welcome":"Welcome","Start":"Start","Imprint":"Imprint","Privacy policy":"Privacy policy","Application version":"Application version","API version":"API version"}}')
  delete Component.options._Ctor
}
